/**
 * The only file that differs between branches.
 *
 * This branch (`style-18-12-2025`) pins the backend host the same way the rest of the
 * app does in services/api.js (`baseAxios`), which hardcodes it and keeps the
 * REACT_APP_API_BASE line commented out on purpose: the value configured for this site
 * resolves back to the site's own origin, so the API call would hit the static build
 * instead of Laravel.
 *
 * On the Vite branch (`style`) the body is:
 *   import.meta.env.REACT_APP_API_BASE || `${window.location?.origin || ""}/api`
 */
export const API_BASE = "https://stage.roadway-moving-ny.com/api";

export const getApiBase = () => API_BASE;

/**
 * The coordinator's API token — the SAME login/password as the rest of the stage
 * app (POST /api/login). Stored in sessionStorage; sent as Bearer on every
 * mc-ops call so the backend derives the MC from the token (not a spoofable id).
 */
const TOKEN_KEY = "mc_ops_token";

export const getMcToken = () => {
  try {
    return sessionStorage.getItem(TOKEN_KEY) || "";
  } catch (e) {
    return "";
  }
};

export const setMcToken = (token) => {
  try {
    if (token) sessionStorage.setItem(TOKEN_KEY, token);
  } catch (e) {
    /* ignore */
  }
};

export const clearMcToken = () => {
  try {
    sessionStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    /* ignore */
  }
};

/**
 * Admin "act as coordinator" — the id of the coordinator an admin is currently
 * viewing. Sent as `view_as` on every mc-ops call; the backend only honors it
 * for see-all users. Cached in sessionStorage so it survives navigation.
 */
const VIEW_AS_KEY = "mc_view_as";

export const getViewAs = () => {
  try {
    return sessionStorage.getItem(VIEW_AS_KEY) || "";
  } catch (e) {
    return "";
  }
};

export const setViewAs = (id) => {
  try {
    if (id) sessionStorage.setItem(VIEW_AS_KEY, String(id));
    else sessionStorage.removeItem(VIEW_AS_KEY);
  } catch (e) {
    /* ignore */
  }
};
